import { useIntl } from 'react-intl';

import {
  CONSUMER_NOT_FOUND,
  INVALID_RECAPTCHA,
  PIN_CODE_BLOCKED,
  RECAPTCHA_REQUEST_DENIED,
} from '../../../../../constants/errors';
import { useBind } from '../../../../../hooks/use-bind/use-bind';
import { useSnackbar } from '../../../../../hooks/use-snackbar/use-snackbar';
import { useModal } from 'mui-modal-provider';
import { useUnknownErrorModal } from '../../../../../hooks/use-unknown-error-modal/use-unknown-error-modal';

export const useResetPasswordError = () => {
  const { enqueueSnackbar } = useSnackbar();
  const enqueueSnackbarBind = useBind(enqueueSnackbar);
  const intl = useIntl();
  const { showModal } = useModal();
  const showUnknownErrorModal = useUnknownErrorModal(showModal);

  const handleError = (error: any) => {
    if (error.response) {
      const { status, data: { errors } } = error.response;
      const { code } = errors[0];

      switch (status) {
        case 400:
          if (code === PIN_CODE_BLOCKED) {
            enqueueSnackbarBind.current(
              intl.formatMessage(
                { id: 'resetPassword.errors.oneInMinute' },
              ),
              { variant: 'error' },
            );
          } else if (code === CONSUMER_NOT_FOUND) {
            enqueueSnackbarBind.current(
              intl.formatMessage(
                { id: 'resetPassword.errors.wrongNumber' },
              ),
              { variant: 'error' },
            );
          }  else if (code === INVALID_RECAPTCHA || code === RECAPTCHA_REQUEST_DENIED) {
            showUnknownErrorModal();
          }
          break;
        default:
          showUnknownErrorModal();
          break;
      }
    } else {
      showUnknownErrorModal();
    }
  };

  return { handleError };
};
